import React from 'react'
import { Info } from 'react-feather'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

interface Props {
  isViewingForm?: boolean
}

const RqCompliantFeeSharingTooltip: React.FC<Props> = ({
  isViewingForm = false,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Info
        className="text-primary ml-1"
        size={14}
        style={{ marginTop: '-2px' }}
      />
    </TooltipTrigger>

    <TooltipContent side="bottom">
      Fee sharing agreements are a hassle. In addition to 'accounting to your
      client', you need to chase your referral partners for updates and
      invoices. RQ can do this for you.{' '}
      {isViewingForm && (
        <>
          Click 'yes' to enable this functionality. If you'd like to learn more,
          use the chat to speak with our team.
        </>
      )}
    </TooltipContent>
  </Tooltip>
)

export default RqCompliantFeeSharingTooltip
